import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from '../components/Navbar';
import { useAuth } from '../context/AuthContext';
import MainContent from '../layouts/Content';

function Layout({ children }) {
  const { user } = useAuth();

  if (!user) {
    return children || <Outlet />;
  }

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900 font-sans">
      <AppNavbar />
      <MainContent>{children || <Outlet />}</MainContent>
    </div>
  );
}

export default Layout;
